(function () {
    var items = document.querySelectorAll('.toolbar__menu-item--has-dropdown');
    if (!items.length) return;

    // Visibility is driven ONLY by the .is-open class (see CSS) — no CSS
    // :hover is used for the panel itself, because the panel is visually
    // far below the trigger (it spans the full header width, starting
    // under the whole header, not right under the word "Shop"/"Blog").
    // A raw :hover would break the instant the cursor crosses the gap
    // between the link and the panel. Instead we open on mouseenter and
    // close on mouseleave with a short grace timer, cancelled if the
    // cursor lands back on the trigger OR the panel before it fires —
    // that's what lets the mouse travel diagonally down into the panel
    // without the menu closing underneath it.
    var CLOSE_DELAY = 300;
    var closeTimer = null;
    // Курсор физически находится над триггером или панелью прямо сейчас —
    // если да, скролл НЕ должен закрывать мега-меню (пользователь мог
    // прокручивать колесом мыши, не уводя курсор с открытого меню).
    var isPointerOverMenu = false;

    function openItem(item) {
      clearTimeout(closeTimer);
      items.forEach(function (el) {
        if (el !== item) setOpen(el, false);
      });
      setOpen(item, true);
    }

    function setOpen(item, isOpen) {
      item.classList.toggle('is-open', isOpen);
      var trigger = item.querySelector(':scope > a');
      if (trigger) trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    function scheduleCloseAll() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        items.forEach(function (el) { setOpen(el, false); });
      }, CLOSE_DELAY);
    }

    function cancelClose() {
      clearTimeout(closeTimer);
    }

    items.forEach(function (item) {
      var trigger = item.querySelector(':scope > a');
      var panel = item.querySelector('.toolbar-megamenu');
      if (!trigger) return;

      item.addEventListener('mouseenter', function () {
        isPointerOverMenu = true;
        openItem(item);
      });
      item.addEventListener('mouseleave', function () {
        isPointerOverMenu = false;
        scheduleCloseAll();
      });
      if (panel) {
        panel.addEventListener('mouseenter', function () {
          isPointerOverMenu = true;
          cancelClose();
        });
        panel.addEventListener('mouseleave', function () {
          isPointerOverMenu = false;
          scheduleCloseAll();
        });
      }

      trigger.addEventListener('click', function (e) {
        // Still a normal link: only intercept the very first activation
        // (e.g. a tap on touch devices, where there is no hover) to reveal
        // the mega menu instead of navigating straight away.
        if (!item.classList.contains('is-open')) {
          e.preventDefault();
          openItem(item);
        }
      });

      trigger.addEventListener('focus', function () { openItem(item); });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.toolbar__menu-item--has-dropdown')) {
        items.forEach(function (el) { setOpen(el, false); });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') items.forEach(function (el) { setOpen(el, false); });
    });

    // Закрываем мега-меню при скролле страницы — НО только если курсор
    // сейчас не находится над самим меню (триггером или панелью).
    // Причина бага "всё пропадает при скролле": шапка здесь НЕ sticky (не
    // зафиксирована), она обычный элемент в потоке документа. Панель
    // мега-меню позиционируется абсолютно от неё же, поэтому при скролле
    // уезжает вместе с шапкой вверх экрана — но помимо этого браузер сам
    // молча стреляет synthetic mouseleave/mouseenter на элементах под
    // курсором в момент скролла (курсор физически неподвижен, а контент
    // под ним уезжает), и наш существующий грейс-таймер закрытия из-за
    // этого срабатывал непредсказуемо — на глаз выглядело как "всё
    // содержимое исчезает". Явный обработчик scroll закрывает меню чисто
    // и предсказуемо в общем случае, но если пользователь прокручивает
    // колесом мыши, находясь курсором прямо над открытым мега-меню (флаг
    // isPointerOverMenu), закрывать его не нужно — он явно продолжает
    // им пользоваться.
    window.addEventListener('scroll', function () {
      if (isPointerOverMenu) return;
      clearTimeout(closeTimer);
      items.forEach(function (el) { setOpen(el, false); });
    }, { passive: true });

    // ===== Бейдж "NEW" всегда в конце ПЕРВОЙ строки названия =====
    // Чистым CSS этого не сделать: в обычном потоке бейдж уезжает в конец
    // ПОСЛЕДНЕЙ строки, а float/absolute прижимают его к правому краю
    // колонки — и между концом текста и бейджем остаётся пустой хвост
    // строки (заказчик видел это как "большой отступ"). Поэтому считаем,
    // какое слово фактически заканчивает первую строку, и склеиваем бейдж
    // именно с этим словом неразрывной обёрткой.
    //
    // Текст названия каждый раз читается заново из DOM, а не запоминается:
    // на переведённых сторефронтах приложение-переводчик подменяет его уже
    // после загрузки, и закэшированный вариант вернул бы английский текст.
    // По той же причине раскладка повторяется через 1.5с после старта —
    // к этому моменту переводчик успевает отработать.
    function readLabelText(label, badge) {
      var text = '';
      (function walk(node) {
        for (var i = 0; i < node.childNodes.length; i++) {
          var child = node.childNodes[i];
          if (child === badge) continue;
          if (child.nodeType === 3) text += child.textContent;
          else walk(child);
        }
      })(label);
      return text.replace(/\s+/g, ' ').trim();
    }

    function layoutBadge(label) {
      var badge = label.querySelector('.toolbar-megamenu__badge-new');
      if (!badge) return;

      var words = readLabelText(label, badge).split(' ').filter(Boolean);
      if (!words.length) return;

      var available = label.clientWidth;
      if (!available) return;

      var labelStyle = window.getComputedStyle(label);
      var probe = document.createElement('span');
      probe.style.cssText =
        'position:absolute;top:0;left:-9999px;visibility:hidden;white-space:nowrap;' +
        'font:' + labelStyle.font + ';letter-spacing:' + labelStyle.letterSpacing;
      document.body.appendChild(probe);

      var badgeStyle = window.getComputedStyle(badge);
      var badgeWidth = badge.getBoundingClientRect().width +
        (parseFloat(badgeStyle.marginLeft) || 0);

      // Сколько слов помещается в первую строку ВМЕСТЕ с бейджем.
      var fit = words.length;
      for (var i = 1; i <= words.length; i++) {
        probe.textContent = words.slice(0, i).join(' ');
        if (probe.getBoundingClientRect().width + badgeWidth > available) {
          fit = i - 1;
          break;
        }
      }
      probe.parentNode.removeChild(probe);
      if (fit < 1) fit = 1;

      var head = words.slice(0, fit - 1).join(' ');
      var glued = words[fit - 1];
      var tail = words.slice(fit).join(' ');

      label.textContent = '';
      if (head) label.appendChild(document.createTextNode(head + ' '));
      var keep = document.createElement('span');
      keep.className = 'toolbar-megamenu__badge-keep';
      keep.appendChild(document.createTextNode(glued));
      keep.appendChild(badge);
      label.appendChild(keep);
      if (tail) label.appendChild(document.createTextNode(' ' + tail));
    }

    function layoutBadges() {
      var labels = document.querySelectorAll('.toolbar-megamenu__entry-label');
      for (var i = 0; i < labels.length; i++) layoutBadge(labels[i]);
    }

    layoutBadges();
    setTimeout(layoutBadges, 1500);

    var badgeResizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(badgeResizeTimer);
      badgeResizeTimer = setTimeout(layoutBadges, 150);
    });
  })();
